import RemoteImage from '@atoms/RemoteImage';
import appStyles from '@root/appStyles';
import colors from '@theme/colors';
import { scale, verticalScale } from '@utils/normalize';
import React from 'react';
import { TouchableOpacity } from 'react-native';
import logSubProdClick from './analyticsSubProduct';
import styles from './styles';

type BPSubProductTileProps = {
  productConfig?: Record<string, any>;
  selectedProductItem?: string;
  productItem?: string;
  iconLink?: string;
  setSelectedProductItem?: (item: string) => void;
  isFavourite?: boolean;
};

function getSelectedBGColor(selectedIndex?: string, index?: string): string {
  return selectedIndex === index ? colors.secondary.softOrchid : colors.neutral.cotton;
}

function getSelectedBorderColor(selectedIndex?: string, index?: string): string {
  return selectedIndex === index ? colors.secondary.orchid : colors.neutral.cotton;
}

const BPSubProductTile: React.FC<BPSubProductTileProps> = ({
  productConfig = {},
  selectedProductItem = '',
  productItem = '',
  iconLink = '',
  setSelectedProductItem = () => {},
  isFavourite = false,
}) => (
  <TouchableOpacity
    testID={productItem}
    style={[
      appStyles.borderWithShadow,
      styles.subProductTile,
      {
        borderColor: getSelectedBorderColor(selectedProductItem, productItem),
        backgroundColor: getSelectedBGColor(selectedProductItem, productItem),
      },
    ]}
    onPress={() => {
      logSubProdClick(productItem, productConfig, isFavourite);
      setSelectedProductItem(productItem);
    }}>
    <RemoteImage width={scale(62)} height={verticalScale(28)} contentFit="cover" uri={iconLink} />
  </TouchableOpacity>
);

export default BPSubProductTile;
